
































import { computed, defineComponent, toRefs, onMounted, watch, PropType, ref } from '@vue/composition-api';
import { createLogger, queryToJson, sleepFn } from '@tt4b/ttam-utils';
import { InventoryFlow, AdgroupFormData, FullNormalFormData } from '@tt4b/ttam-enums';
import CreativePreviewer from './../common/creative-previewer/index';

import NoPreviewIcon from '@tt4b/ttam-assets/src/svgs/no-preview.svg';
import PreviewCta from './preview-cta/index.vue';
import { useGetPreviewProducts, useGetCatalogTitle, useProductRenderMeta, useSelectVideoPackage } from './hook';
import { StateEnum, useStore } from '@tt4b/ttam-hooks';

const logger = createLogger('TtamCatalogsPreviewCompose');

const name = 'ttam-cla-preview-compose';
export default defineComponent({
  name,
  components: {
    CreativePreviewer,
    PreviewCta,
    NoPreviewIcon,
  },
  props: {
    adgroupData: {
      type: Object as PropType<AdgroupFormData>,
      required: true,
    },
    creativeFormData: {
      type: Object as PropType<FullNormalFormData>,
      required: true,
      default: () => ({} as FullNormalFormData),
    },
    templateId: {
      type: String,
    },
    displayName: {
      type: String,
      default: '',
    },
    avatarIcon: {
      type: String,
      default: '',
    },
  },
  setup(props, { emit }) {
    const { aadvid } = queryToJson();
    const { adgroupData, creativeFormData, displayName, avatarIcon } = toRefs(props);

    const catalogId = computed(() => adgroupData.value.productPlatformId);
    const bcId = computed(() => adgroupData.value.catalogAuthorizedBc);
    const pSetId = computed(() => creativeFormData.value.productSetId);
    const productIds = computed(() => creativeFormData.value.dpaProducts);
    const templateId = computed(() => creativeFormData.value.videoTplName);

    const { state } = useStore();
    const catalogWordList = computed(() => state[StateEnum.catalogLexiconList].data.value);

    const { previewProductList, remote, getPreviewProducts, isLoading } = useGetPreviewProducts(
      catalogId,
      bcId,
      pSetId,
      productIds,
    );

    const queryKey = ref('');
    const filterProductList = computed(() =>
      previewProductList.value.filter(product => product.OuterID?.indexOf?.(queryKey.value) > -1),
    );

    const { productRenderError, setNoProductError } = useProductRenderMeta(catalogId, bcId);

    const curPreviewProducts = ref();

    const config = computed(() => {
      const curPreviewProductsVal = curPreviewProducts.value || previewProductList.value[0];
      const configVal = {
        apps: [InventoryFlow.TIKTOK],
        info: {
          name: displayName.value,
          avatar: avatarIcon.value,
        },
        material: {
          type: 'image',
          price: curPreviewProductsVal?.price?.stdPrice,
          productTitle: curPreviewProductsVal?.title,
          media: {
            type: 'image',
            imageUrl: curPreviewProductsVal?.image?.url,
          },
        },
        otherInfo: {
          aadvid,
          isLoading: isLoading?.value,
        },
        placementControl: {
          tiktokRecommendAds: true,
        },
      };
      logger.debug('CatalogsPreview videoConfig=%s', configVal);
      return configVal;
    });

    const onChange = item => {
      curPreviewProducts.value = item;
    };

    const onQuery = (outerId: string) => {
      if (remote.value) {
        getPreviewProducts({ outerId });
      } else {
        queryKey.value = outerId;
      }
    };

    const onUpdatePreviewProducts = async () => {
      queryKey.value = '';
      await getPreviewProducts();
      if (!previewProductList.value?.length) {
        setNoProductError();
      }
      curPreviewProducts.value = undefined;
    };

    const onClickErrorCta = () => {
      productRenderError?.value?.ctaCb?.();
    };

    onMounted(() => {
      watch(() => pSetId.value + templateId.value + JSON.stringify(productIds.value), onUpdatePreviewProducts);
      onUpdatePreviewProducts();
    });

    return {
      name,
      config,
      remote,
      isLoading,
      previewProductList,
      filterProductList,
      productRenderError,
      onQuery,
      onChange,
      onClickErrorCta,
      catalogWordList,
    };
  },
});
